import DOMPurify from "dompurify";
import MarkdownIt from "markdown-it";

const MARKDOWN_IT = new MarkdownIt();

export const markdownToHtml = (markdown?: string | null): string => {
  if (!markdown) return "";

  const dirty = MARKDOWN_IT.render(markdown);
  return DOMPurify.sanitize(dirty, {
    USE_PROFILES: { html: true },
    ADD_TAGS: ["img"],
    ADD_ATTR: ["src", "alt", "loading"],
  });
};

/**
 * Action blocks are only turned into an <ActionCard> once the message is complete
 * (chat-message.tsx runs parseMarkdownIntoSegments behind `isMessageComplete`). Until then the
 * raw ```action fence streams straight into <Markdown>, so the user watches the JSON payload
 * type itself out in a code block before it is replaced by the button. Hide it while streaming;
 * the closing fence is optional so a half-received block is hidden too.
 */
function stripActionBlocks(content: string): string {
  return content.replace(/(^|\n)```action\b[\s\S]*?(?:\n```|$)/g, "$1");
}

export function getMarkdownReadyToDisplay(content: string | undefined, isStreaming: boolean): string | undefined {
  if (!content) return undefined;
  if (!isStreaming) return content;

  /** Strips an incomplete markdown link only if it sits at the very end of the string. */
  const TRAILING_INCOMPLETE_LINK = /\[[^\]]*(?:\](?:\([^)]*)?)?$/;

  return stripActionBlocks(content).replace(TRAILING_INCOMPLETE_LINK, "");
}
